import firebase from './firebase';

export function log(type: string, data?: any) {
    firebase
        .firestore()
        .collection('logs')
        .add({
            type,
            data,
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        });
}
